import { gql } from '@apollo/client/core';

export const ADD_MODULE_ELECTIVES = gql`
  mutation AddModuleElectives($moduleId: ID!, $calendarId: ID!, $courseIds: [ID!]!) {
    addModuleElectiveOfferings(module_id: $moduleId, academic_calendar_id: $calendarId, course_ids: $courseIds) { success message }
  }
`;

export const REMOVE_MODULE_ELECTIVE = gql`
  mutation RemoveModuleElective($moduleId: ID!, $offeringId: ID!) {
    removeModuleElectiveOffering(module_id: $moduleId, offering_id: $offeringId) { success message }
  }
`;
